module.exports = __webpack_public_path__ + "static/media/14UNEP4.cde1a90c.jpg";